import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "tabIndex", "className", "children", "type", "iconName", "disabledSpaceKey", "isTooltip"];
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { ROOT_PREFIX, StyledStatusIcon, StyledSimpleIcon } from './styles';

/** AccessibleIcon currently only supports two keys [space, enter] to trigger OnClick event **/

export var AccessibleIcon = function AccessibleIcon(_ref) {
  var onClick = _ref.onClick,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    className = _ref.className,
    children = _ref.children,
    type = _ref.type,
    iconName = _ref.iconName,
    disabledSpaceKey = _ref.disabledSpaceKey,
    isTooltip = _ref.isTooltip,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var handleKeyUp = function handleKeyUp(e) {
    e.key === ' ' && !disabledSpaceKey && (onClick === null || onClick === void 0 ? void 0 : onClick());
  };
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.key) {
      case ' ':
        // to prevent default scroll behavior
        !disabledSpaceKey && e.preventDefault();
        break;
      case 'Enter':
        onClick === null || onClick === void 0 || onClick();
        break;
      default:
        break;
    }
  };
  return type ? /*#__PURE__*/React.createElement(StyledStatusIcon, _extends({
    className: classnames(ROOT_PREFIX, _defineProperty({}, "".concat(ROOT_PREFIX, "-icon-only"), !children), className),
    onClick: onClick,
    tabIndex: tabIndex,
    onIconKeyUp: handleKeyUp,
    onIconKeyDown: handleKeyDown,
    type: type,
    iconName: iconName,
    isTooltip: isTooltip
  }, otherProps), children) : /*#__PURE__*/React.createElement(StyledSimpleIcon, _extends({
    className: classnames(ROOT_PREFIX, className, iconName),
    onClick: onClick,
    tabIndex: tabIndex,
    onKeyUp: handleKeyUp,
    onKeyDown: handleKeyDown
  }, otherProps));
};